// API Configuration utility
// Handles API URL detection for web, Electron, and production environments

export const getAPIUrl = () => {
  // Check if running in Electron
  const isElectron = window.navigator && window.navigator.userAgent.toLowerCase().includes('electron');
  
  // If Electron, check environment variable or use production URL
  if (isElectron) {
    return process.env.REACT_APP_API_URL || 'https://dineflowbackend.onrender.com';
  }
  
  // For web browsers, check hostname
  const hostname = window.location.hostname;
  
  // Support localhost and local network IPs (e.g. 192.168.x.x, 10.x.x.x)
  const isLocalIP = hostname === 'localhost' || 
                    hostname.endsWith('.localhost') ||
                    hostname === '127.0.0.1' || 
                    hostname.startsWith('192.168.') || 
                    hostname.startsWith('10.') || 
                    /^172\.(1[6-9]|2[0-9]|3[0-1])\./.test(hostname);

  if (isLocalIP) {
    return `http://${hostname}:5000`;
  }
  
  // Production/deployed environment
  return process.env.REACT_APP_API_URL || 'https://dineflowbackend.onrender.com';
};

export const API_URL = getAPIUrl();
